import { useState } from "react";
import GerenciarMetasExtra from "../../components/GerenciarMetasExtra/GerenciarMetasExtra";
import NotifierPopup from "../../components/NotifierPopup/NotifierPopup";

export default function GerenciarMetasExtraAdm() {
   const [notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });

    const handleEditarNotifier = (ok, msg) => {
      setNotify({isActive: true, isSuccessful: ok, message: msg});
    };

  return (
    <>
    {notify.isActive && 
    <NotifierPopup notify={notify} setNotify={setNotify}/>
    }

    <GerenciarMetasExtra setNotifier={handleEditarNotifier}/>
    </>
  );
}